import type { Offer } from '@/api/types';

export function formatOfferLabel(o: Offer): string {
  const dash = '—';
  const partner = o.partner || dash;
  const geo = o.geo || dash;
  const brand = o.brand && o.brand.trim() ? o.brand : dash;
  const lang = o.lang && o.lang.trim() ? o.lang : dash;
  return `${partner} / ${geo} / ${brand} / ${lang}`;
}

export function formatPayoutCents(cents: number | null): string {
  if (cents == null) return '—';
  return `$${(cents / 100).toFixed(2)}`;
}
